import React from 'react'
import useItems from '../../../hooks/use-hours'
import { find } from 'lodash'

const LabelItem = ({ hourId }) => {
    const [ hours ] = useItems()
    const item = find(hours, { id: hourId })
    const name = item ? item.name : ''
    return (
        <React.Fragment>{name}</React.Fragment>
    )
}

export default LabelItem